module.exports = __webpack_public_path__ + "static/media/11_l_fonar_15.16_60.93.b0443735.png";